import axios from "axios";

import UrlUtils from "../common/utils/url";

export default class Search {
    constructor() {
        this._init();
    }

    _init() {
        this._loadJson();
    }

    _loadJson() {
        const query = UrlUtils.getQuery() || {};
        const jsonName = query.year === "2022" ? "parameter_2022" : "parameter";

        const PARAM_JSON_URL = `/daigaku/shiryo_cp/resources/json/${jsonName}.json?${new Date().getTime()}`;
        const ERROR_DAIGAKU_URL = `/daigaku/shiryo_cp/resources/json/comon_no-material.json?${new Date().getTime()}`;
        const ERROR_SENMON_URL = `/daigaku/shiryo_cp/resources/json/senmon_no-material.json?${new Date().getTime()}`;

        Promise.all([this._getJson(PARAM_JSON_URL), this._getJson(ERROR_DAIGAKU_URL), this._getJson(ERROR_SENMON_URL)])
            .then((res) => {
                const paramJson = JSON.parse(JSON.stringify(res[0]));
                const errJson = {
                    dai: JSON.parse(JSON.stringify(res[1])),
                    sen: JSON.parse(JSON.stringify(res[2])),
                };

                this._complete(paramJson, errJson);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    _getJson(url) {
        return axios
            .get(url)
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                console.log(err);
            });
    }

    _complete(paramJson, errJson) {
        [...document.querySelectorAll(".js-search-main")].forEach(($searchMain) => {
            const search = new SearchTool($searchMain, paramJson, errJson);
        });
    }
}

class SearchTool {
    constructor(parent, paramJson, errJson) {
        this.SEND_URL = "https://manabi.benesse.ne.jp/shiryo/gutapp/s/crt/cartInsert.do";

        this.$parent = parent;
        this.$kensaku = this.$parent.querySelector(".js-search__kensaku a");
        this.$noEntry = this.$parent.querySelector(".js-search__noentry");
        this.$currentPulldown = null;

        this.cat = this.$parent.getAttribute("data-key");
        this.paramJson = paramJson;
        this.errJson = errJson;
        this.select = { learning: null, area: null };

        this._ui();

        if (location.href.indexOf("?senmon") > -1) {
            this.$parent.querySelector('.js-search-tab[data-key="sen"]').click();
        }
    }

    _ui() {
        [...this.$parent.querySelectorAll(".js-search-trigger")].forEach(($label) => {
            const text = $label.textContent;
            $label.setAttribute("data-label", text);
        });

        // タブ切り替え
        [...this.$parent.querySelectorAll(".js-search-tab")].forEach(($tab) => {
            const key = $tab.getAttribute("data-key");

            $tab.addEventListener("click", () => {
                this._resetPullDown();
                this.$parent.setAttribute("data-key", key);
                this.cat = key;
                this._tabReset();
            });
        });

        // プルダウンの表示と非表示
        [...this.$parent.querySelectorAll(".js-search-trigger")].forEach(($trigger) => {
            $trigger.addEventListener("click", (e) => {
                e.stopPropagation();

                if (this.$currentPulldown) {
                    this.$currentPulldown.style.top = 0;
                    this.$currentPulldown.classList.remove("-active");
                }
                this.$currentPulldown = $trigger.nextElementSibling;
                this.$currentPulldown.classList.add("-active");
                this._setSelectPos();
            });
        });

        document.addEventListener("click", (e) => {
            if (this.$currentPulldown) {
                this.$currentPulldown.style.top = 0;
                this.$currentPulldown.classList.remove("-active");
                this.$currentPulldown = null;
            }
        });

        // 選択する
        [...this.$parent.querySelectorAll(".js-search-btn")].forEach(($btn) => {
            $btn.addEventListener("click", (e) => {
                e.stopPropagation();

                // ラベルの更新
                this._setLabel($btn);

                // データセット
                this._setData($btn);

                // 入力状況のチェック
                this._checkInput();

                // アクティブなボタンを更新
                [...this.$currentPulldown.querySelectorAll(".js-search-btn")].forEach(($elem) => {
                    $elem.classList.remove("-active");
                });
                $btn.classList.add("-active");

                // プルダウンを閉じる
                this.$currentPulldown.style.top = 0;
                this.$currentPulldown.classList.remove("-active");
                this.$currentPulldown = null;
            });
        });
    }

    _setSelectPos() {
        const rect = this.$currentPulldown.getBoundingClientRect();
        const wh = window.innerHeight;

        if (wh < rect.bottom) {
            const val = wh - rect.bottom - 20;
            this.$currentPulldown.style.top = `${val}px`;
        }
    }

    _setLabel($btn) {
        const txt = $btn.textContent;
        const $label = this.$currentPulldown.previousElementSibling;
        $label.textContent = txt;
    }

    _setData($btn) {
        const idx = parseInt($btn.getAttribute("data-index"));
        const key = this.$currentPulldown.getAttribute("data-key");
        this.select[key] = idx === 99 ? null : idx;
    }

    _checkInput() {
        if (this.select.learning != null && this.select.area != null) {
            const param = this.paramJson[this.cat][this.select.learning].area[[this.select.area]];
            this.$kensaku.setAttribute("href", this.SEND_URL + param);
            this.$kensaku.classList.add("-active");

            if (this._checkNoEntry()) {
                this.$kensaku.classList.remove("-active");
                this.$noEntry.classList.add("-active");
            } else {
                this.$noEntry.classList.remove("-active");
            }
        } else {
            this.$kensaku.classList.remove("-active");
        }
    }

    _tabReset() {
        this.$kensaku.setAttribute("href", "");
        this.$kensaku.classList.remove("-active");
        this.$noEntry.classList.remove("-active");
        this.select = { learning: null, area: null };
    }

    _resetPullDown() {
        [...this.$parent.querySelectorAll(".js-search-trigger")].forEach(($label) => {
            const txt = $label.getAttribute("data-label");
            $label.textContent = txt;
        });

        [...this.$parent.querySelectorAll(".js-search-btn")].forEach(($btn) => {
            const idx = $btn.getAttribute("data-index");

            if (idx == 99) {
                $btn.classList.add("-active");
            } else {
                $btn.classList.remove("-active");
            }
        });

        if (this.$currentPulldown) {
            this.$currentPulldown.style.top = 0;
            this.$currentPulldown.classList.remove("-active");
            this.$currentPulldown = null;
        }
    }

    _checkNoEntry() {
        const json = this.errJson[this.cat];
        const key = this.cat === "dai" ? "learning" : "job";

        for (let i = 0; i < json.length; i++) {
            if (this.select.learning === parseInt(json[i][key]) && this.select.area === parseInt(json[i].area)) {
                return true;
            }
        }

        return false;
    }
}
